import ReadOnlyField from 'app/components/ReadOnlyField';

/* redux-form wrapper around the ReadOnlyField component
 */
const ReadOnlyFieldReduxForm = ({ input, ...rest }) => (
  <ReadOnlyField {...rest} value={input?.value} />
);

export default ReadOnlyFieldReduxForm;
